// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width: 1280px) {\n.custom-responsive[data-v-6487d0f1] {\n    width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
